/* Welcome pop-up + filters */
(function () {
  'use strict';
  function store(get, val) {
    try { if (get) return window.localStorage.getItem('sx_quiz_seen_v1'); window.localStorage.setItem('sx_quiz_seen_v1', val); } catch (e) { return null; }
  }
  function initQuiz() {
    var d = document.querySelector('[data-quiz]');
    if (!d || !d.showModal) return;
    function open() { if (!d.open) d.showModal(); }
    function close() { if (d.open) d.close(); store(false, '1'); }
    d.querySelectorAll('[data-quiz-close]').forEach(function (b) { b.addEventListener('click', close); });
    d.querySelectorAll('[data-quiz-pick]').forEach(function (a) { a.addEventListener('click', function () { store(false, '1'); }); });
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.addEventListener('cancel', function () { store(false, '1'); });
    if (d.getAttribute('data-design') === '1') {
      document.addEventListener('shopify:section:select', function (e) { if (d.closest('.shopify-section') && e.target === d.closest('.shopify-section')) open(); });
      document.addEventListener('shopify:section:deselect', function () { if (d.open) d.close(); });
      return;
    }
    if (store(true)) return;
    var delay = Number(d.getAttribute('data-delay') || 6) * 1000;
    setTimeout(open, delay);
  }
  function initFilters() {
    var f = document.querySelector('[data-filters]');
    if (f && window.matchMedia('(min-width: 990px)').matches) f.open = true;
  }
  function boot() { initQuiz(); initFilters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
